import React from "react";
import * as S from "./style";
import DashboardLayout from "defaultComponents/LayoutContainers/DashboardLayout";
import DashboardNavbar from "defaultComponents/Navbars/DashboardNavbar";
import { Grid } from "@mui/material";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import breakpoints from "assets/theme/base/breakpoints";
import { RiHandHeartFill, RiMovie2Fill } from "react-icons/ri";
import filter from "assets/icons/filter.svg";
import TiktokCommunity from "./components/Community";
import TiktokVideos from "./components/Videos";
import { useParams } from "react-router-dom";
import { getDetailedMetrics } from "utils/requests/other";
import { TokenContext } from "context/TokenContext";

const Tiktok = () => {
  const params = useParams();
  const [tabsOrientation, setTabsOrientation] = React.useState("horizontal");
  const [tabValue, setTabValue] = React.useState("community");
  const [socialData, setSocialData] = React.useState({});
  const handleSetTabValue = (event, newValue) => setTabValue(newValue);
  const { decodedToken } = React.useContext(TokenContext);
  
  async function fetchDetailedMetrics () {
    const username = params?.influencer || decodedToken?.username;
    const response = await getDetailedMetrics(username, null, null, 'Tiktok');
    return response;
  }
  
  function handleTabsOrientation() {
    return window.innerWidth < breakpoints.values.lg
      ? setTabsOrientation("vertical")
      : setTabsOrientation("horizontal");
  }

  React.useEffect(() => {
    window.addEventListener("resize", handleTabsOrientation);
    handleTabsOrientation();
    window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  React.useEffect(() => {
    const fetchData = async () => {
      const data = await fetchDetailedMetrics();
      setSocialData(data);
    };
    fetchData();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container spacing="18px">
        <Grid item xs={12} lg={12} xl={12}>
          <S.EditButton>
            <img src={filter} />
          </S.EditButton>
          <Grid container item justifyContent="center">
            <Tabs
              orientation={tabsOrientation}
              value={tabValue}
              onChange={handleSetTabValue}
              sx={{ background: "transparent", display: "flex", justifyContent: "flex-end" }}
            >
              <Tab
                label="COMUNIDADE"
                value="community"
                icon={<RiHandHeartFill color="white" size="16px" />}
              />
              <Tab label="VIDEOS" value="videos" icon={<RiMovie2Fill color="white" size="16px" />} />
            </Tabs>
          </Grid>
        </Grid>
        {tabValue === "community" && <TiktokCommunity socialData={socialData}/>}
        {tabValue === "videos" && <TiktokVideos socialData={socialData}/>}
      </Grid>
    </DashboardLayout>
  );
};

export default Tiktok;
